import Stepper from 'react-stepper-horizontal';
import React from 'react';
interface StepperProps {
  activeNum: number;
}

const steps = [{ title: '授業情報' }, { title: '入手・掲載元' }, { title: '著作物情報' }];

const Step = React.memo((props: StepperProps) => {
  return (
    <div className="stepper-wrapper">
      <Stepper steps={steps} activeStep={props.activeNum} size={32} circleTop={10} circleFontSize={20} titleFontSize={13} titleTop={3} />
    </div>
  );
});

export default Step;
